import { z } from 'zod'

export const KlaviyoSchemas = {
  getLists: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({
      lists: z.array(z.object({ list_id: z.string(), list_name: z.string() })),
    }),
  },
  getFields: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({
      fields: z.array(z.object({ key: z.string(), isWritable: z.boolean() })),
    }),
  },
}
